import endSound from "./assets/end-listening.mp3";
import startSound from "./assets/start-listening.mp3";

import activeSuggestionIcon from "./assets/active-alternative.svg";
import activeMicIcon from "./assets/active-microphone.svg";
import inActiveSuggestionIcon from "./assets/inactive-alternative.svg";
import inActiveMicIcon from "./assets/inactive-microphone.svg";

import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";

import "./assets/speech-plugin-style.css";

export default class Speech extends Plugin {
  static get pluginName() {
    return "Speech";
  }
  constructor(editor) {
    super(editor);

    this.sourceElement = null;
    this.editor = editor;
    this.speechRecorder = null;
    this.recordButton = null;
    this.languageToggleButton = null;
    this.suggestionButton = null;
    this.suggestionsList = {};
    this.restartingMic = false;

    this.init();
  }

  init() {
    this.speechRecognitionInstance();
    if (!this.speechRecorder) return;

    this.speechRecInitialConfig();

    this.addButtons.bind(this)();

    this.editor.ui.componentFactory.add("speech", () => {
      return this.recordButton;
    });

    this.editor.ui.componentFactory.add("language-toggle", () => {
      return this.languageToggleButton;
    });

    this.editor.ui.componentFactory.add("suggest-toggle", () => {
      return this.suggestionButton;
    });

    this.addListeners.bind(this)();
  }

  addButtons() {
    this.recordButton = new ButtonView();
    this.languageToggleButton = new ButtonView();
    this.suggestionButton = new ButtonView();
    this.suggestionButton.set({
      tooltip: "نمایش چند پیشنهادی موتور تبدیل گفتار به متن",
      isOn: true,
      withText: false,
      icon: activeSuggestionIcon,
    });
    this.languageToggleButton.set({
      label: "FA",
      tooltip: "تغییر زبان موتور شنیداری فارسی/انگلیسی",
      isOn: false,
      withText: true,
    });
    this.recordButton.set({
      label: "Speech",
      tooltip: "تبدیل گفتار به متن",
      tooltipPosition: "s",
      withText: false,
      isEnabled: Boolean(this.speechRecorder),
      isOn: false,
      icon: inActiveMicIcon,
      class: "record-button",
    });
  }

  turnMicOn() {
    this.recordButton.set({
      icon: activeMicIcon,
    });
    this.speechRecorder.start();
  }

  turnMicOff() {
    this.recordButton.set({
      icon: inActiveMicIcon,
    });
    this.speechRecorder.abort();
    this.speechRecorder.stop();
  }

  restartMic() {
    this.restartingMic=true;
    if (this.recordButton.isOn) {
      this.turnMicOff();
      setTimeout(() => {
        this.turnMicOn();
        setTimeout(()=>{
          this.restartingMic = false;
        },100)
      }, 100);
    } else {
      this.turnMicOff();
      this.restartingMic = false;
    }
  }

  speechRecInitialConfig() {
    this.speechRecorder.continuous = true;
    this.speechRecorder.lang = "fa-IR";
    this.speechRecorder.interimResults = false;
    this.speechRecorder.maxAlternatives = 3;
  }

  speechRecognitionInstance() {
    if (
      window.hasOwnProperty("webkitSpeechRecognition") ||
      window.hasOwnProperty("SpeechRecognition")
    ) {
      this.speechRecorder =
        new window.webkitSpeechRecognition() || new window.SpeechRecognition();
    } else {
      this.speechRecorder = null;
    }
  }

  addTextToCK(txt) {
    const enableSuggestion = false
    this.editor.model.schema.extend("paragraph", {
      allowAttributes: ["class", "id"],
      isBlock: false,
      isInline: true,
    });

    this.editor.conversion.attributeToAttribute({
      model: "class",
      view: "class",
    });

    this.editor.conversion.attributeToAttribute({
      model: "id",
      view: "id",
    });

    let objIdx = "";

    const writer = this.editor.model.change((writer) => {
      if (txt.length > 1 && enableSuggestion) {
        objIdx = String(Object.keys(this.suggestionsList).length);
        const p1 = writer.createElement("paragraph", {
          id: `paragraph-${objIdx}`,
          class: "suggestion-p",
        });

        this.suggestionsList = { ...this.suggestionsList, [`${objIdx}`]: txt };

        const docFrag = writer.createDocumentFragment();
        writer.insertText(txt[0].toString(), p1);
        writer.append(p1, docFrag);
        return docFrag;
      } else {
        if(txt[0].toString() === "") {
          return null
        }
        const p1 = writer.createElement("paragraph", { id: "suggestion" });
        const docFrag = writer.createDocumentFragment();
        writer.append(p1, docFrag);
        writer.insertText(" " + txt[0].toString(), p1);
        return docFrag;
      }
    });

    if(writer)
      this.editor.model.insertContent(writer);

    const paragraphElement = this.sourceElement.querySelector(`suggestion`);

    if(!paragraphElement) {
      this.restartMic()
    }
  }

  handleShowSuggestionBox(e) {
    const prevBox = this.sourceElement.querySelector("#suggestion-box");

    if (prevBox) {
      prevBox.remove();
    }

    const idx = e.target.id.split("-")[1];
    if (!idx) return;
    const texts = this.suggestionsList[idx];
    if (!texts) return;

    const recordElm = this.sourceElement.querySelector(".record-button");
    const ckBox = this.sourceElement.querySelector(".ck-editor__top");
    const box = document.createElement("div");
    box.classList.add(this.languageToggleButton.isOn ? "rtl" : "ltr");
    box.id = "suggestion-box";

    texts.forEach((el) => {
      const spanElm = document.createElement("span");
      spanElm.classList.add("suggest-text");
      spanElm.innerHTML = String(el);
      spanElm.title = String(el);
      spanElm.onclick = () => {
        this.sourceElement
          .querySelector(`#paragraph-${idx}`)
          .removeEventListener(
            "click",
            this.handleShowSuggestionBox.bind(this)
          );
        e.target.innerHTML = el;
        e.target.id = "";
        e.target.classList.remove("suggestion-p");
        this.sourceElement
          .querySelectorAll(`#paragraph-${idx}`)
          .forEach((itm) => {
            itm.remove();
          });
        box.remove();
      };
      box.append(spanElm);
    });

    ckBox.append(box);
  }

  addListeners() {
    // editor is mounted and ready
    this.editor.on("ready", (e) => {
      this.sourceElement = e.source.sourceElement.nextElementSibling;
    });

    // recordButton execute
    this.recordButton.on("execute", () => {
      if (this.recordButton.isOn) {
        this.turnMicOff();
      } else {
        this.turnMicOn();
      }
    });

    // speech rec stop
    this.speechRecorder.addEventListener("end", () => {
      if(this.restartingMic){
        return;
      }
      this.recordButton.set({
        isOn: false,
        icon: inActiveMicIcon,
      });
      if (!this.sourceElement.querySelector("#end-rec-sound")) {
        const endListeningSound = new Audio(endSound);
        endListeningSound.id = "end-rec-sound";
        this.sourceElement.append(endListeningSound);
      }

      this.sourceElement.querySelector("#end-rec-sound").play();
    });

    // speech rec start
    this.speechRecorder.addEventListener("start", () => {
      if(this.restartingMic)
        return
      this.recordButton.set({
        isOn: true,
        icon: activeMicIcon,
      });

      if (!this.sourceElement.querySelector("#start-rec-sound")) {
        const startListeningSound = new Audio(startSound);
        startListeningSound.id = "start-rec-sound";
        this.sourceElement.append(startListeningSound);
      }

      this.sourceElement.querySelector("#start-rec-sound").play();
    });

    // toggle language
    this.languageToggleButton.on("execute", () => {
      this.languageToggleButton.isOn = !this.languageToggleButton.isOn;
      this.languageToggleButton.label = this.languageToggleButton.isOn
        ? "EN"
        : "FA";
      this.speechRecorder.lang = this.languageToggleButton.isOn
        ? "en-US"
        : "fa-IR";
      this.restartMic();
    });

    // suggestion toggle
    this.suggestionButton.on("execute", () => {
      this.suggestionButton.isOn = !this.suggestionButton.isOn;
      this.suggestionButton.icon = this.suggestionButton.isOn
        ? activeSuggestionIcon
        : inActiveSuggestionIcon;
      this.speechRecorder.maxAlternatives = this.suggestionButton.isOn ? 3 : 1;
      this.restartMic();
    });

    // speech on result event
    this.speechRecorder.onresult = (event) => {
      const results = event.results[event.results.length - 1];
      if (results.length > 1) {
        const texts = Object.keys(results)
          .map((itm) => results[itm].transcript)
          .filter((itm) => Boolean(itm));
        this.addTextToCK(texts);
      } else {
        this.addTextToCK([results[0].transcript]);
      }
    };
  }
}
